import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/protocol', // 协议
      name: 'protocol',
      component: r => require.ensure([], () => r(require('@/pages/protocol/index.vue')), 'protocol'),
    },
    {
      path: '/travelMonitoring', // 行程监控
      name: 'travelMonitoring',
      component: r => require.ensure([], () => r(require('@/pages/travelMonitoring/index.vue')), 'travelMonitoring'),
    },
    {
      path: '/chargeDetails/standard', //  国家标准模式
      name: 'chargeDetailsStandard',
      component: r => require.ensure([], () => r(require('@/pages/chargeDetails/standard/index.vue')), 'chargeDetails'),
    },
    {
      path: '/spreaderRegisting', // 推广注册
      name: 'spreaderRegisting',
      component: r => require.ensure([], () => r(require('@/pages/spreaderRegisting/index.vue')), 'spreaderRegisting'),
    },
    {
      path: '/spreaderRegisted', // 推广注册后
      name: 'spreaderRegisted',
      component: r => require.ensure([], () => r(require('@/pages/spreaderRegisted/index.vue')), 'spreaderRegisted'),
    },
    {
      path: '/pcOrderDetails', // 拼车订单详情
      name: 'pcOrderDetails',
      component: r => require.ensure([], () => r(require('@/pages/pcOrderDetails/index.vue')), 'pcOrderDetails'),
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js